import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';

@Pipe({
  name: 'localeDate'
})
export class LocaleDatePipe implements PipeTransform {

  constructor(private readonly translateService: TranslateService) {}

  transform(
    date: Date | string,
    locale?: string,
    format: string = 'L LT'
  ): string {
    const useLocale = locale || this.translateService.instant('locale') || 'pt-BR';
    return moment(date).locale(useLocale).format(format);
  }

}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/pipe/locale-date.pipe.ts